module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-page-view"
  }, [_c('div', {
    staticClass: "search-view"
  }, [_c('div', {
    staticClass: "search-item-view"
  }, [_c('div', {
    staticClass: "search-title"
  }, [_vm._v("\n        搜索视频:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.searchData.searchText),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "searchText", $$v)
      },
      expression: "searchData.searchText"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "medium"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("\n          搜索\n        ")])], 1)]), _vm._v(" "), _c('VideoUploadView', {
    ref: "videoUploadView",
    on: {
      "handleSuccess": _vm.handleUploadVideoSuccess
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sketch-view"
  }, [(_vm.loginStatus) ? _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_vm._v("\n        当前登录用户:" + _vm._s(_vm.platformUserData.userName) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.showUploadVideo
    }
  }, [_vm._v("\n          上传视频\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.showReg
    }
  }, [_vm._v("\n          用户注册\n        ")])], 1)]), _vm._v(" "), (!_vm.loginStatus) ? _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("\n          用户登录\n        ")])], 1)]) : _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("\n          退出登录\n        ")])], 1)])]), _vm._v(" "), _c('VideoView', {
    attrs: {
      "videoList": _vm.dataList
    },
    on: {
      "commentSuccess": _vm.commentSuccess,
      "resetCurrentPage": _vm.resetCurrentPage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-view"
  }, [_c('div', {
    staticClass: "pagination-item-view"
  }, [_c('el-pagination', {
    attrs: {
      "background": true,
      "current-page": _vm.paginationData.currentPage,
      "page-sizes": [5, 10, 60, 80, 100, 200, 300],
      "page-size": _vm.paginationData.itemsPerPage,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.paginationData.totalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('RegisterView', {
    ref: "registerView",
    on: {
      "handleSuccess": _vm.regSuccess
    }
  }), _vm._v(" "), _c('LoginView', {
    ref: "loginView",
    on: {
      "handleSuccess": _vm.loginSuccess
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72183408", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72183408"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/VideoByMeList.vue
// module id = 1304
// module chunks = 1